var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"15","height":"2","fill":"#626774","key":0}),React.createElement("rect",{"y":"5.5","width":"15","height":"2","fill":"#626774","key":1}),React.createElement("rect",{"y":"11","width":"15","height":"2","fill":"#626774","key":2})]);
}

Menu.defaultProps = {"width":"15","height":"13","viewBox":"0 0 15 13","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
